import {Physician} from "../model/physician/Physician";

export class PhysicianSaveCommand{
    physician: Physician;

    constructor(physician:Physician){
        this.physician = physician;
    }
}